<template>
  <div class="matrix-form">
    <ul v-for="(row, index) in rows" :key="row.row_id" class="mb-3 last:mb-0">
      <li>
        <div class="relative" :class="{ 'pr-10': hasRowIcon }">
          <div class="my-1" v-html="row.content.richText || row.content.text"></div>
          <slot name="row-icon" :row="row" :index="index"></slot>
        </div>
        <slot name="content" :row="row"></slot>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'MatrixForm',
  props: {
    columns: {
      type: Array,
      default: () => []
    },
    rows: {
      type: Array,
      default: () => []
    },
    columnKey: {
      type: [Number, String]
    },
    showColText: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  computed: {
    hasRowIcon() {
      return !!this.$scopedSlots['row-icon']
    }
  },
  created() {},
  methods: {}
}
</script>

<style scoped></style>
